import './collection.scss';
import React, { useEffect, useState, useRef, useCallback } from "react";
import { ListGroup, Accordion, Card, Row, Col, Container, Button, Image, ListGroupItem} from "react-bootstrap";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faEllipsisH, faPlus, faChevronLeft, faMapMarkerAlt, faDirections } from "@fortawesome/free-solid-svg-icons";
import { withRouter, NavLink, Link } from "react-router-dom";
import ApiV2 from "../apiV2"

function Collection(props) {
    const [collectionOwner, setCollectionOwner] = useState({});
    const [spotCount, setSpotCount] = useState(null);

    useEffect(() => {
        const fetchOwner = async () => {
        try {
            const response = await ApiV2.getUser(props.collection.owner);
            setCollectionOwner(response)
            
        } catch (error) {
            console.log("unable to fetch user. Error: ", JSON.stringify(error));
        }
    }
    fetchOwner();
    }
        , []
    );

    useEffect(() => {
        const fetchCount = async () => {
        try {
            const response = await ApiV2.getCollectionSpotCount(props.collection.id);
            setSpotCount(response.data.Count)
            
        } catch (error) {
            console.log("Unable to fetch spot count. Error: ", JSON.stringify(error));
        }
    }
    fetchCount();
    }
        , []
    );
    

    if(props.collectionType === 'SAVED'){
        return (
            <>
            <Card className="country-cards mb-1">
                <NavLink to={props.collectionPath} onClick={() => props.setSelectedSharelist({data: props.collection})}>
                    <Card.Img className="country-card-image" variant="top" src="https://arzotravels.com/wp-content/uploads/2019/07/town-hall-3620496_1280-1280x640.jpg" />
                </NavLink>
                    <Card.Body className="pl-0 pr-0 pt-1 pb-1">
                            <Row>
                                <Col>
                                    {props.collection.name}
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    {/* <FontAwesomeIcon onClick={() => this.openModal(sharelist)} className="fa-lg mr-1 blue" icon={faEllipsisH} /> */}
                                </Col>
                            </Row>
                            <Row>
                            <Col xs={8}>
                                <p className="place-text text-secondary mb-0">Owner: {collectionOwner?.firstName?.charAt(0).toUpperCase() + collectionOwner?.firstName?.slice(1) + " " + collectionOwner?.lastName?.charAt(0).toUpperCase() + collectionOwner?.lastName?.slice(1)}</p>
                            </Col>
                            <Col className="d-flex justify-content-end" xs={4}>
                                <p className="place-text text-secondary mb-0">{spotCount} Spots</p>
                            </Col>

                            </Row>
                    </Card.Body>
            </Card>
            </>
        );
    } else {
        return(
            <>
                <Card className="country-cards mb-1">
                    <NavLink to={props.collectionPath} onClick={() => props.setSelectedSharelist({data: props.collection})}>
                        <Card.Img className="country-card-image" variant="top" src="https://arzotravels.com/wp-content/uploads/2019/07/town-hall-3620496_1280-1280x640.jpg" />
                    </NavLink>
                        <Card.Body className="pl-0 pr-0 pt-1 pb-1">
                                <Row>
                                    <Col>
                                        {props.collection.name}
                                    </Col>
                                    <Col className="d-flex justify-content-end align-items-center">
                                        <FontAwesomeIcon onClick={() => props.openModal(props.collection)} className="fa-lg mr-1 blue" icon={faEllipsisH} />
                                    </Col>
                                </Row>
                            <p className="place-text text-secondary mb-0">{spotCount} Spots</p>
                        </Card.Body>
                </Card>
            </>
        )
    }
}

Collection.propTypes = {
  collection: PropTypes.object.isRequired,
  collectionType: PropTypes.string.isRequired,
  collectionPath: PropTypes.string.isRequired,
  setSelectedSharelist: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

export default withRouter(Collection);
